import type { SVGProps } from "react";
const SvgHome06 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="M7.551 4.022 2.7 8.268c-.416.364-.137 1.01.436 1.01.35 0 .634.263.634.586v2.703c0 2.326 0 3.488.782 4.21.783.723 2.041.723 4.559.723h1.78c2.518 0 3.776 0 4.558-.722.783-.723.783-1.885.783-4.21V9.863c0-.323.284-.585.634-.585.573 0 .852-.647.436-1.011l-4.852-4.246C11.289 3.007 10.709 2.5 10 2.5c-.71 0-1.29.507-2.449 1.522"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.667}
      d="M10 13.333h.008"
    />
  </svg>
);
export default SvgHome06;
